const ProfileCardIcon = ({
  className = "",
  height = "40",
  width = "45",
  fill = "none",
  stroke = "#939393",
  rx="6"
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 45 40"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="0.25" width="44" height="40" rx={rx} fill="#EBEBEB" />
    <rect width="18" height="18" transform="translate(13 11)" fill="#EBEBEB" />
    <path
      d="M28 26.75C28 25.7033 28 25.18 27.8708 24.7541C27.58 23.7953 26.8297 23.045 25.8709 22.7542C25.445 22.625 24.9217 22.625 23.875 22.625H20.125C19.0783 22.625 18.555 22.625 18.1291 22.7542C17.1703 23.045 16.42 23.7953 16.1292 24.7541C16 25.18 16 25.7033 16 26.75M25.375 16.625C25.375 18.489 23.864 20 22 20C20.136 20 18.625 18.489 18.625 16.625C18.625 14.761 20.136 13.25 22 13.25C23.864 13.25 25.375 14.761 25.375 16.625Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProfileCardIcon;
